import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { FundingProduct } from '@frontend/components/agromarket/core/access-control'
import type { FundingProductCards } from '@/api/kubik/credit'
import { useGetApprovedRegions } from '@/api/kubik/credit'
import type { ILoanProductsFilterForm } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsFilter/types'
import { INCREASE_LOAN_AMOUNT_BANNER_PRODUCT_INDEX } from '@/pages/Financing/components/FinancingProducts/components/LoanProducts/components/LoanProductsList/constants'

export const useIncreaseLoanAmountBanner = (products: FundingProductCards[]) => {
  const form = useFormContext<ILoanProductsFilterForm>()
  const { userRegion } = useUserRegion()

  const { data } = useGetApprovedRegions({
    productId: FundingProduct.REPORT_CTRL2GO,
  })
  const formRegionCode = form.watch('regionCode')

  const shouldShowInLoansList = useMemo(() => {
    if (!formRegionCode) {
      const isRegionInHeaderApproved = data?.approvedRegions?.includes(userRegion.code) === true

      return isRegionInHeaderApproved
    }

    const isRegionInFormApproved = data?.approvedRegions?.includes(Number(formRegionCode)) === true

    return isRegionInFormApproved
  }, [data?.approvedRegions, formRegionCode, userRegion.code])

  const indexToInsert = useMemo(() => {
    if (!shouldShowInLoansList) {
      return 0
    }

    const mfoIndex = products.findIndex(({ productId }) => productId === FundingProduct.EXPRESS_MFO)
    const advanceFundingIndex = products.findIndex(({ productId }) => productId === FundingProduct.ADVANCE_FUNDING)
    const maxIndex = Math.max(mfoIndex, advanceFundingIndex)

    if (maxIndex === -1) {
      return INCREASE_LOAN_AMOUNT_BANNER_PRODUCT_INDEX
    }

    return maxIndex + 1
  }, [products, shouldShowInLoansList])

  return {
    shouldShowInLoansList,
    indexToInsert,
  }
}
